import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'
import { Color } from '../color/Color'

export enum OtaConnectionStatusId {
  ACTIVE = 'active',
  PENDING = 'pending',
  INACTIVE = 'inactive',
  NONE = 'none',
}

export class OtaConnectionStatus extends Codebook<OtaConnectionStatusId> {
  static readonly ACTIVE = new OtaConnectionStatus(OtaConnectionStatusId.ACTIVE, () => $t('Active'))
  static readonly PENDING = new OtaConnectionStatus(OtaConnectionStatusId.PENDING, () =>
    $t('Pending'),
  )
  static readonly NONE = new OtaConnectionStatus(OtaConnectionStatusId.NONE, () => $t('None'))
  static readonly INACTIVE = new OtaConnectionStatus(OtaConnectionStatusId.INACTIVE, () =>
    $t('Inactive'),
  )

  private constructor(
    id: OtaConnectionStatusId,
    public name: () => string,
  ) {
    super(id)
  }

  isActive = (): boolean => {
    return this.id === OtaConnectionStatusId.ACTIVE
  }

  isPending = (): boolean => {
    return this.id === OtaConnectionStatusId.PENDING
  }

  isInactive = (): boolean => {
    return this.id === OtaConnectionStatusId.INACTIVE
  }

  isConnected = (): boolean => {
    return this.isActive() || this.isPending() || this.isInactive()
  }

  getColor = (): Color.POSITIVE | Color.WARNING | Color.NEGATIVE => {
    switch (this.id) {
      case OtaConnectionStatusId.ACTIVE:
        return Color.POSITIVE
      case OtaConnectionStatusId.PENDING:
      case OtaConnectionStatusId.INACTIVE:
        return Color.WARNING
      case OtaConnectionStatusId.NONE:
        return Color.NEGATIVE
    }
  }

  getIcon = (): string => {
    switch (this.id) {
      case OtaConnectionStatusId.ACTIVE:
        return 'check'
      case OtaConnectionStatusId.PENDING:
      case OtaConnectionStatusId.INACTIVE:
        return 'hourglass'
      case OtaConnectionStatusId.NONE:
        return 'ban'
    }
  }
}
